export type Archetype =
  | 'servant'
  | 'devotee'
  | 'sensualist'
  | 'primal'
  | 'brat'
  | 'little';

export const ARCHETYPE_ORDER: Archetype[] = [
  'servant',
  'devotee',
  'sensualist',
  'primal',
  'brat',
  'little',
];

export type Likert = 1 | 2 | 3 | 4 | 5;

export interface Question {
  id: string;
  archetype: Archetype;
  prompt: string;
}

export type Answers = Record<string, Likert>;
export type Scores = Record<Archetype, number>;

export interface SavedConstellation {
  scores: Scores;
  name: string;
  createdAt: string;
  version: 1;
}
